import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);
dayjs.extend(timezone);

export default function buildAlertsPlotData(data, yAxisVar) {
  // const MARKER_SIZE_OFFSET = 4;
  // const MARKER_SIZE_SCALING = 2;

  if (!data) {
    return [];
  }

  const groupedData = Object.groupBy(data, (datum) => datum.uuid);

  const plotData = [];

  const markers = new Map();

  markers.set("JAM", "diamond");
  markers.set("ACCIDENT", "triangle-up");
  markers.set("HAZARD", "star");
  markers.set("WEATHERHAZARD", "hexagram");
  markers.set("ROAD_CLOSED", "circle-x-open");
  markers.set("UNKNOWN", "square-x-open");

  for (const [label, symbol] of markers) {
    plotData.push({
      x: [null],
      y: [null],
      legendgroup: "group2",
      legendgrouptitle: {
        text: "Type d'alerte",
        itemsizing: "trace",
      },
      name: label,
      mode: "markers",
      marker: {
        size: 14,
        color: "rgb(0, 0, 0)",
        symbol: symbol,
      },
    });
  }

  for (const [key, value] of Object.entries(groupedData)) {
    plotData.push({
      x: value.reduce(
        (accumulator, currentValue) =>
          accumulator.concat(
            dayjs(currentValue.time).tz("Europe/Zurich").format(),
          ),
        [],
      ),
      y: value.reduce(
        (accumulator, currentValue) =>
          accumulator.concat(currentValue[yAxisVar]),
        [],
      ),
      text: value.reduce(
        (accumulator, currentValue) =>
          accumulator.concat(
            `Type: ${currentValue.type}<br>Sous-type: ${currentValue.subtype}<br>D'actualité depuis le ${new Date(currentValue._pub_datetime).toLocaleString("fr", { weekday: "short", year: "2-digit", month: "numeric", day: "numeric", hour: "numeric", minute: "numeric" }).replace(/\//g, "-")}`,
          ),
        [],
      ),
      customdata: value.reduce(
        (accumulator, currentValue) =>
          accumulator.concat(currentValue.geometry_md5),
        [],
      ),
      marker: {
        size: 10,
        symbol: value.reduce(
          (accumulator, currentValue) =>
            accumulator.concat(
              markers.get(currentValue.type)
                ? markers.get(currentValue.type)
                : markers.get("UNKNOWN"),
            ),
          [],
        ),
      },
      name: key,
      type: "scatter",
      mode: "lines+markers",
      legendgroup: "group1",
      legendgrouptitle: {
        text: "UUID",
      },
    });
  }

  return plotData;
}
